<template>
    <div>
        <div class="row mb-3">
            <div class="col">
                <label class="form-label">
                    <i class="ti ti-calendar"></i>
                    Período
                </label>
                <div class="form-selectgroup">
                    <label class="form-selectgroup-item">
                        <input
                            id="1hPeriodInput"
                            v-model="periodType"
                            type="radio"
                            name="period"
                            value="1h"
                            class="form-selectgroup-input"
                        />
                        <span class="form-selectgroup-label">1h</span>
                    </label>
                    <label class="form-selectgroup-item">
                        <input
                            id="1dPeriodInput"
                            v-model="periodType"
                            type="radio"
                            name="period"
                            value="1d"
                            class="form-selectgroup-input"
                        />
                        <span class="form-selectgroup-label">24h</span>
                    </label>
                    <label class="form-selectgroup-item">
                        <input
                            id="7dPeriodInput"
                            v-model="periodType"
                            type="radio"
                            name="period"
                            value="7d"
                            class="form-selectgroup-input"
                        />
                        <span class="form-selectgroup-label">7d</span>
                    </label>
                    <label class="form-selectgroup-item">
                        <input
                            id="15dPeriodInput"
                            v-model="periodType"
                            type="radio"
                            name="period"
                            value="15d"
                            class="form-selectgroup-input"
                        />
                        <span class="form-selectgroup-label">15d</span>
                    </label>
                    <label class="form-selectgroup-item">
                        <input
                            v-model="periodType"
                            type="radio"
                            name="period"
                            value="custom"
                            class="form-selectgroup-input"
                        />
                        <span class="form-selectgroup-label"
                            >Personalizado</span
                        >
                    </label>

                    <div v-show="periodType == 'custom'" class="col-auto">
                        <div class="input-group">
                            <div class="input-group-text">De</div>
                            <input
                                id="filterStartDateInput"
                                v-model="date_start"
                                type="datetime-local"
                                max="2099-12-12T00:00"
                                step="1"
                                class="form-control"
                                @blur="updateRange"
                                @keyup.enter="updateRange"
                            />
                            <div class="input-group-text">Até</div>
                            <input
                                id="filterEndDateInput"
                                v-model="date_end"
                                type="datetime-local"
                                step="1"
                                max="2099-12-12T00:00"
                                class="form-control"
                                @blur="updateRange"
                                @keyup.enter="updateRange"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DateRangePicker",
    props: {
        periodTypeDefault: {
            type: String,
            default: "1h"
        },
        dateStart: {
            type: String,
            default: ""
        },
        dateEnd: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            periodType: "1d",
            date_start: "",
            date_end: ""
        }
    },
    mounted() {
        this.$watch("periodTypeDefault", function (value) {
            this.periodType = value
        })

        this.periodType = this.periodTypeDefault
        this.date_start = this.dateStart
        this.date_end = this.dateEnd

        this.$watch("periodType", (value) => {
            if (value != "custom") {
                this.$emit("periodChange", value)
            }
        })
    },
    methods: {
        updateRange: function () {
            this.$emit("periodChange", this.periodType, {
                date_start: this.date_start,
                date_end: this.date_end
            })
        }
    }
}
</script>
